import clsx from "clsx";
import { MdCancel } from "react-icons/md";

function OrdersList(props) {
  const {
    allQueryFormat = [],
    selectedQuery = {},
    setSelectedQuery = () => { },
    onRemoveOrderQuery = () => { },
    onChangeSelectedQuery = () => { },
    setHideOrder = () => { },
  } = props;

  return (
    <ul className="orders-list-items flex flex-col gap-1 max-h-[calc(100vh-140px)] overflow-y-auto scroll-thin pr-0.5">
      {Array.isArray(allQueryFormat) && allQueryFormat.length ? (
        allQueryFormat.map((query, index) => {
          const selected = selectedQuery._id === query._id;
          return (
            <li
              key={index}
              data-spotlight={index === 0 ? "matrix-cargo-item" : undefined}
              className={clsx(
                "flex items-center justify-between px-2 py-1 rounded-none text-[11px] font-medium transition-all border cursor-pointer select-none",
                selected
                  ? "bg-[#313C4C] text-white border-[#313C4C] shadow-sm"
                  : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100 hover:border-gray-300"
              )}
              onClick={() => {
                onChangeSelectedQuery(query, [], false);
                setHideOrder(true);
              }}
            >
              {/* Query Name */}
              <span className="truncate pr-1">{query.name}</span>

              {/* Remove Button */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onRemoveOrderQuery(query._id);
                }}
                className={clsx(
                  "ml-1 p-0.5 rounded-none transition-colors flex-shrink-0",
                  selected
                    ? "hover:bg-slate-700 text-red-300 hover:text-red-200"
                    : "hover:bg-gray-200 text-red-500 hover:text-red-600"
                )}
                title="Remove Cargo Query"
              >
                <MdCancel className="text-sm" />
              </button>
            </li>
          );
        })
      ) : (
        <li className="text-gray-400 text-xs text-center py-4 italic">
          No Cargo Queries Found.
        </li>
      )}
    </ul>
  );
}

export default OrdersList;
